<template>
    <router-link 
        class="event-speaker-card__speaker" 
        :to="{
            name: 'speaker-by-id',
            params: {
                id: speaker.speaker_id
            }
        }"
        v-bind:style="{background: cardBackground}"
    >
        <Avatar 
            class='event-speaker-card__speaker-avatar' 
            size='60' 
            :avatar='speaker.speaker_logo'
        />
        <p class="event-speaker-card__speaker-name">
            {{ speaker.speaker_name }}
        </p>
        <v-icon class="event-speaker-card__speaker-icon">
            mdi-chevron-right
        </v-icon>
    </router-link>
</template>
<script>
import Avatar from '@/components/Avatar'
export default {
    components: {
        Avatar
    },
    props: {
        speaker: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        cardBackground() {
            return this.$route.name === 'event-speakers' ? '#fff' : '#F3F3F6'
        }
    }
}
</script>
<style lang="scss">
.event-speaker-card {
    &__speaker {
		display: flex;
		flex-wrap: nowrap;
		align-items: center;
		padding: 16px;
		border: 1px solid #E2E2E2;
		border-radius: 12px;
		margin-bottom: 12px;
		text-decoration: none;

		&-avatar {
			margin-right: 24px;
		}

		&-name {
			margin: 0 !important;
			color: var(--accent-color);
			font-family: Montserrat, sans-serif;
			font-size: 14px;
			font-weight: 700;
			line-height: 17.07px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 1;
			-webkit-box-orient: vertical;
			flex-grow: 1;
		}

		&-icon {
			color: #9B9B9B !important;
		}
	}
}
</style>